import { React } from "react";

export const SUPPORT_REQUEST_URL = "https://portal.code-cube.io/support_request";

const openSupportRequest = (e) => {
  e.preventDefault();
  e.stopPropagation();
  window.open(SUPPORT_REQUEST_URL, "_blank", "noopener,noreferrer");
};

export const SupportRequestLink = ({ children = "Please get in contact." }) => (
  <span
    className="support_request_link"
    role="link"
    tabIndex={0}
    onClick={openSupportRequest}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") openSupportRequest(e);
    }}
  >
    {children}
  </span>
);
